import React, {useState, useEffect} from 'react';
import {ActionStatus, genId} from '../components/ActionStatus';
import Action from '../components/Action';

export default function useActionLog () {

  let [actions, setActions] = useState([]);

  useEffect(() => {
    console.log(actions);
    // let newActions = actions;
    // newActions.forEach(action => {
    //   if(!action.hasCallback) {
    //     console.log(`adding callback to ${action.id}`);
    //     action.actionRequest.then(res => {
    //       console.log(`'${action.id}' has status '${res.status}'`)
    //       setStatus(action.id, 1);
    //     }, err => {
    //       console.log(`'${action.id}' has error '${err}'`)
    //       setStatus(action.id, 2);
    //     });
    //     action.hasCallback = true;
    //   }
    // })
    // setActions(newActions);
  }, [actions]);

  function setStatus (actionId, newStatus, detail) {
    setActions((actions) => {
      console.log(`got actions`, actions)
      let actionIndex = actions.findIndex(a => a.id == actionId);
      let updatedAction = actions[actionIndex];
      updatedAction.status = newStatus;
      if (detail) updatedAction.detail = detail;
      return [
        ...actions.slice(0, actionIndex),
        updatedAction,
        ...actions.slice(actionIndex + 1)
      ];
    })
  }

  function removeAction (actionId) {
    setActions(actions => {
      let actionIndex = actions.findIndex(a => a.id == actionId);
      return [
        ...actions.slice(0, actionIndex),
        ...actions.slice(actionIndex + 1)
      ]
    });
  }

  function clearActions() {
    setActions([]);
  }

  return {
    display: () => {
      return <ul className={`ActionLog list-group ${actions.length > 0 ? '' : 'd-none'} ${actions.length == 1 ? 'single-action' : ''}`}>
        <li className="list-group-item ActionLog-heading"><span>{actions.length} Action{actions.length == 1 ? '' : 's'}</span><a className="Action-clearButton btn btn-secondary" onClick={clearActions}>Clear</a></li>
        {actions.map(a => <Action key={"action_" + a.id} status={a.status} title={a.title} detail={a.detail} />)}
      </ul>
    },
    pushAction: async(actionDetails) => {
      console.log("Action added", actionDetails);
      let actionId = genId();

      let newAction = {
        actionRequest: actionDetails.actionRequest,
        title: actionDetails.title,
        detail: actionDetails.detail,
        id: actionId,
        status: 0
      };
      setActions([...actions, newAction]);

      try {
        let res = await actionDetails.actionRequest;
        setStatus(actionId, 1, res.data.message || 'Request Successful');
        setTimeout(() => removeAction(actionId), 3000);
      } catch (err) {
        if(err.response) {
          setStatus(actionId, 2, `${err.response.status}: ${err.response.data.message || 'Request Failed'}`);
        } else {
          setStatus(actionId, 2, err.message);
        }
      }

      return;
    }
  }

}